<template>
<div id="app" class="site hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="content" class="site-content" style="height: auto !important;flex-direction: column;">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <h1>Download GBWhatsApp APK v18.80 - Free & Safe</h1>
        
        <div class="download-features">
          <ul>
            <li>Works on Android 5.0 and above</li>
            <li>Small file size, quick download</li>
            <li>Easy to install and use</li>
            <li>Safe and updated version</li>
          </ul>
        </div>
        
        <p>Click the button below to start your download and enjoy the newest features of <strong>gbwhatsapp.</strong></p>
        
        <div class="download-button-container">
          <button class="download-btn" @click="downloadfrom('main')">
            <svg class="download-btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v8.59l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42L11 12.59V4a1 1 0 0 1 1-1Zm-7 14a1 1 0 0 1 1 1v1h12v-1a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Z"/>
            </svg>
            <span>Download APK</span>
          </button>
        </div>
      </div>
    </section>

    <!-- Download APK Info Section -->
    <section class="download-info-section">
      <div class="container">
        <h2>Download APK Info</h2>
        <div class="table-container">
          <table>
            <tbody>
              <tr>
                <td><strong>App Name</strong></td>
                <td><a href="/" class="app-name-link">GBWhatsApp</a></td>
              </tr>
              <tr>
                <td><strong>Version</strong></td>
                <td>Latest</td>
              </tr>
              <tr>
                <td><strong>Software Category</strong></td>
                <td>App</td>
              </tr>
              <tr>
                <td><strong>Size</strong></td>
                <td>91.2 MB</td>
              </tr>
              <tr>
                <td><strong>Requirement</strong></td>
                <td>Android 5.1+</td>
              </tr>
              <tr>
                <td><strong>Root Requirement</strong></td>
                <td>Non Root</td>
              </tr>
              <tr>
                <td><strong>Last Update</strong></td>
                <td>1 Day Ago</td>
              </tr>
              <tr>
                <td><strong>Total Downloads</strong></td>
                <td>7,022,775</td>
              </tr>
              <tr>
                <td><strong>RATING</strong></td>
                <td>4.5</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- Why Choose Section -->
    <section class="why-choose-section">
      <div class="container">
        <h2>Why Choose GBWhatsApp v18.80?</h2>
        <p>GBWhatsApp gives you more privacy controls, custom themes, and bigger file sharing options compared to the official WhatsApp. This version is stable, reliable, and easy to set up for all Android users.</p>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav,
  },
  mounted() {
    // this.from = this.$global.GetQueryString('from') || this.from;
    // this.filename = this.$global.GetQueryString('filename') || this.filename;
    // console.log(this.$global.GetQueryString('from'));
    // if (this.$global.GetQueryString('from')) {
    //   this.getAPK();
    // } else {
    //   this.getOfficalApk();
    // }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
/* 下载页阅读排版 */
h1 {
  font-size: var(--read-h1, 2.1rem);
  font-weight: 700;
  color: #fff;
  margin-bottom: 1.25rem;
  text-align: center;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

h2 {
  font-size: var(--read-h2, 1.55rem);
  font-weight: 700;
  color: var(--read-text-strong, #1f2937);
  margin-bottom: 1.1rem;
  text-align: center;
  line-height: 1.35;
}

h3 {
  font-size: var(--read-h3, 1.25rem);
  font-weight: 600;
  color: var(--read-text-strong, #1f2937);
  margin-bottom: 0.85rem;
}

.hero-section {
  padding: 3.25rem 0 3rem;
  background: linear-gradient(145deg, var(--brand-primary-dark, #048d3d) 0%, var(--brand-primary, #06c755) 55%, var(--brand-primary-hover, #05a949) 100%);
  color: white;
  text-align: center;

  h1 {
    color: white;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.05rem;
    line-height: 1.75;
    margin-bottom: 1.75rem;
    max-width: none;
    margin-left: auto;
    margin-right: auto;
    opacity: 0.95;
  }
}

.download-features {
  margin: 1.75rem 0;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;

    li {
      list-style: none;
      background: rgba(255, 255, 255, 0.14);
      padding: 0.55rem 1rem;
      width: fit-content;
      border-radius: 999px;
      border: 1px solid rgba(255, 255, 255, 0.22);
      font-size: 0.95rem;
      line-height: 1.4;
    }
  }
}

.download-button-container {
  margin-top: 1.75rem;

  .download-btn {
    /* 白底绿字，在绿色 Hero 上对比更强 */
    background: #ffffff;
    color: var(--brand-primary-dark, #048d3d);
    border: 2px solid #ffffff;
    padding: 1.05rem 2.25rem;
    font-size: 1.2rem;
    font-weight: 800;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.25s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.55rem;
    line-height: 1.2;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.22);

    .download-btn-icon {
      width: 1.2em;
      height: 1.2em;
      flex-shrink: 0;
    }

    &:hover {
      background: #f0fdf4;
      color: var(--brand-primary-dark, #048d3d);
      border-color: #f0fdf4;
      transform: translateY(-2px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.28);
    }
  }
}

.download-info-section {
  padding: 3rem 0;
  background: var(--read-bg-soft, #f8fafc);

  .table-container {
    max-width: none;
    margin: 0 auto;

    table {
      width: 100%;
      border-collapse: collapse;
      background: white;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid var(--read-border, #e5e7eb);
      box-shadow: 0 1px 4px rgba(15, 23, 42, 0.05);

      td {
        padding: var(--table-cell-pad-y, 0.65rem) var(--table-cell-pad-x, 0.85rem);
        border-bottom: 1px solid #eef2f7;
        font-size: var(--table-font-size, 1rem);
        line-height: var(--table-line-height, 1.6);
        letter-spacing: var(--table-letter-spacing, 0);
        font-weight: var(--table-font-weight, 400);

        &:first-child {
          background: #f8fafc;
          font-weight: var(--table-th-weight, 600);
          width: 36%;
          color: var(--read-text-strong, #1f2937);
        }

        &:last-child {
          color: var(--read-text, #374151);
        }
      }

      tr:last-child td {
        border-bottom: none;
      }
    }
  }

  .app-name-link {
    color: var(--read-link, #06c755);
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 0.2s ease;

    &:hover {
      color: var(--read-link-hover, #05a949);
    }
  }
}

.why-choose-section {
  padding: 3rem 0 3.5rem;
  background: white;

  p {
    font-size: var(--read-size, 1.0625rem);
    line-height: var(--read-lh, 1.8);
    color: var(--read-text, #374151);
    max-width: none;
    margin: 0 auto;
    text-align: center;
  }
}

.container {
  width: 80%;
  max-width: none;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  h1 {
    font-size: 1.7rem;
  }

  h2 {
    font-size: 1.35rem;
  }

  h3 {
    font-size: 1.15rem;
  }

  .hero-section {
    padding: 2.4rem 0 2.2rem;
  }

  .download-features ul {
    flex-direction: column;
    align-items: center;
  }

  .download-info-section,
  .why-choose-section {
    padding: 2.2rem 0;
  }

  .container {
    width: 100%;
    padding: 0 16px;
  }
}
</style>
